"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlayService = void 0;
const app_1 = require("app");
class OverlayService {
    constructor() {
        this.isOverlayVisible = false;
        this.header = document.querySelector('.header');
        this.fixedClassName = ['fixed', 'overflow-hidden', 'w-full'];
        this.enableBodyScrollLock = () => {
            const scrollPosition = window.scrollY;
            this.addScrollBarPlaceholder();
            document.body.classList.add(...this.fixedClassName);
            document.body.style.top = `-${scrollPosition}px`;
            this.isOverlayVisible = true;
        };
        this.disableBodyScrollLock = () => {
            const scrollPosition = document.body.style.top;
            document.body.classList.remove(...this.fixedClassName);
            this.removeScrollBarPlaceholder();
            document.body.style.top = '';
            if (scrollPosition && window.scroll) {
                window.scroll(0, parseInt(scrollPosition) * -1);
            }
            setTimeout(() => {
                this.isOverlayVisible = false;
            }, 150);
        };
        this.addScrollBarPlaceholder = () => {
            const offset = window.innerWidth - app_1.UtilService.getElementWidthWithoutPaddings(document.body);
            if (offset > 0) {
                document.body.style.paddingRight = `${offset}px`;
            }
            if (this.header && offset > 0) {
                this.header.style.right = `${offset}px`;
            }
        };
        this.removeScrollBarPlaceholder = () => {
            document.body.style.paddingRight = '';
            if (this.header) {
                this.header.style.right = '';
            }
        };
        this.removeBodyOverflow = () => {
            document.body.style.removeProperty('overflow');
        };
    }
}
exports.overlayService = new OverlayService();
